// extracted by mini-css-extract-plugin
export default {"delete-account":"DeleteAccount_delete-account__sFyKP"};